import { render, staticRenderFns } from "./GroupVideos.vue?vue&type=template&id=0edf6db5&"
import script from "./GroupVideos.vue?vue&type=script&lang=js&"
export * from "./GroupVideos.vue?vue&type=script&lang=js&"
import style0 from "./GroupVideos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GroupVideos.vue"
export default component.exports